// https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-ScaleRangeSlider-ScaleRanges.html#RecommendedScales
const scales = [
  { name: 'continent', scale: 50000000 },
  { name: 'countries-big', scale: 25000000 },
  { name: 'countries-small', scale: 12000000 },
  { name: 'states-provinces', scale: 6000000 },
  { name: 'state-province', scale: 3000000 },
  { name: 'counties', scale: 1500000 },
  { name: 'county', scale: 750000 },
  { name: 'metropolitan-area', scale: 320000 },
  { name: 'cities', scale: 160000 },
  { name: 'city', scale: 80000 },
  { name: 'town', scale: 40000 },
  { name: 'neighborhood', scale: 20000 },
  { name: 'streets', scale: 10000 },
  { name: 'street', scale: 5000 },
  { name: 'buildings', scale: 2500 },
  { name: 'building', scale: 1250 },
  { name: 'small-building', scale: 800 },
  { name: 'rooms', scale: 400 },
  { name: 'room', scale: 100 }, // ESRI definitions stop here
  { name: 'desk', scale: 50 },
  { name: 'workspace', scale: 10 },
  { name: 'monitor', scale: 5 },
  { name: 'screen', scale: 1 }
];

export const MIN_SCALE_AS_BIG_COUNTRIES = getMinScaleAsBigCountries();
export const ScalesDictionaryReducedToBigCountries =
  reduceScaleToBigCountries();

function reduceScaleToBigCountries() {
  const startIndex = scales.findIndex(scale => scale.name === 'countries-big');
  return scales.slice(startIndex);
}

function getMinScaleAsBigCountries() {
  const startIndex = scales.findIndex(scale => scale.name === 'countries-big');
  return scales[startIndex].scale;
}
